export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.6.15-0819.11",
  commitId: "7423a2ee0c91f04c36384e0b3e611140e8a0fc47",
  commitTime: "2026-06-15T08:19:11.000Z",
});
